
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/details/[uri]",
      function () {
        return require("private-next-pages/courses/details/[uri]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/details/[uri]"])
      });
    }
  